import { Card } from "@/src/components/wrappers/Card";
import { Content } from "@/src/components/wrappers/Content";
import { ActionButton, BackButton, WithActionBar } from "@/src/components/wrappers/WithActionBar";
import { EditOperatorForm } from "./EditOperatorForm/EditOperatorForm";
import { ChevronRight } from "lucide-react";
import { useToast } from "@/src/components/ui/use-toast";
import { useFetch } from "@/src/lib/useFetch";
import { OperatorForm } from "./EditOperatorForm/operator.schema";
import { useNavigate } from "react-router-dom";

export function AddOperator() {
  const { isFetching, fetch } = useFetch();
  const { toast } = useToast();
  const navigate = useNavigate();

  const postOperator = async (data: OperatorForm) => {
    if (!isFetching) {
      try {
        const res = await fetch<{ data: { id: string } }>(`/api/operators/operators`, "POST", data);
        toast({
          title: "Operator saved",
          description: "The operator has been saved",
          variant: "default",
        });
        navigate(`/operators/${res.data.id}`);
      } catch (e: any) {
        console.error(e);
        toast({
          title: "Failed to save operator",
          description: e.message || "An error occurred while saving the operator",
          variant: "destructive",
        });
      }
    }
  };

  return (
    <WithActionBar actionBar={<ActionBar />}>
      <Content title="Add a non-API operator">
        <Card>
          <EditOperatorForm onSubmit={postOperator} />
        </Card>
      </Content>
    </WithActionBar>
  );
}

function ActionBar() {
  return (
    <div className="flex justify-between items-center">
      <BackButton />
      <ActionButton eventKey="operator:save" type="button">
        Save Operator <ChevronRight size={16} className="ml-2" />
      </ActionButton>
    </div>
  );
}
